'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSize = exports.getType = exports.getExtension = exports.getName = exports.getUrl = exports.getExpiresAt = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _fileMetadataKeyPaths = require('../constants/fileMetadataKeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getExpiresAt = exports.getExpiresAt = (0, _getIn2.default)(_fileMetadataKeyPaths.EXPIRES_AT);

var getUrl = exports.getUrl = (0, _getIn2.default)(_fileMetadataKeyPaths.URL);

var getName = exports.getName = (0, _getIn2.default)(_fileMetadataKeyPaths.NAME);

var getExtension = exports.getExtension = (0, _getIn2.default)(_fileMetadataKeyPaths.EXTENSION);

var getType = exports.getType = (0, _getIn2.default)(_fileMetadataKeyPaths.TYPE);

var getSize = exports.getSize = (0, _getIn2.default)(_fileMetadataKeyPaths.SIZE);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/file-metadata/operators/fileMetadataGetters.js
// module id = 308
// module chunks = 2 3